<template>
    <div class="row mt-2">
        <div class="col-12">
            <div class="form-group">
                <label for="formatpicker">
                    {{$t('LAYOUTEDITOR.choosePreviewFormat')}}
                </label>
                <multiselect v-model="selected"
                             :deselect-label="$t('UI.cantRemove')"
                             track-by="id"
                             label="id"
                             :placeholder="$t('UI.selectOne')"
                             id="formatpicker"
                             :options="options"
                             :searchable="false"
                             :allow-empty="false"
                             @select="$emit('selected', $event)"
                ></multiselect>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import Multiselect from 'vue-multiselect';

export default {
    name: 'FormatSelection',
    data () {
        return {
            selected: this.selectedFormat || {}
        };
    },
    props: {
        selectedFormat: {
            type:  Object
        },
        options: {
            type: [Object, Array]
        }
    },
    components: {
        Multiselect
    }
    
};

</script>

<style lang="scss" scoped>

</style>
